// src/services/PartnerService.js
import { useState, useEffect } from 'react';
import axios from 'axios';

const PartnerService = () => {
  const [partnerMap, setPartnerMap] = useState(new Map());

  useEffect(() => {
    const loadPartners = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const token = localStorage.getItem("token");

        // Fetch partners from API
        const response = await axios.get(`${apiUrl}/hms-partners/list`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        let partners = [];

        if (response.data.success && Array.isArray(response.data.partners)) {
          // Filter active partners
          partners = response.data.partners
            .filter((partner) => partner.status === "active")
            .map((partner) => ({
              value: partner.id.toString(),
              label: partner.name,
            }));
        }

        // Include the same built-in booking sources used by SelectPartner so
        // reservation details can resolve their stored IDs back to readable names.
        const staticOptions = [
          { value: "-101", label: "Airbnb" },
          { value: "-102", label: "MMT" },
          { value: "-103", label: "Google / Website (Direct)" },
          { value: "-104", label: "Repeat (Direct)" },
          { value: "-105", label: "Referral / Whatsapp Group" },
          { value: "0", label: "Walk-In" },
          { value: "-106", label: "Instagram" },
          { value: "-107", label: "Other" },
          { value: "1", label: "Corporate" },
        ];

        // Configured partner IDs take precedence if a property already has a
        // partner with the same source name (for example Airbnb).
        const configuredLabels = new Set(
          partners.map((item) => item.label.trim().toLowerCase().replace(/\s+/g, " "))
        );
        const missingStaticOptions = staticOptions.filter(
          (item) => !configuredLabels.has(item.label.trim().toLowerCase().replace(/\s+/g, " "))
        );

        const combined = [...missingStaticOptions, ...partners];

        // Create Map of id => name
        const map = new Map(combined.map(item => [item.value, item.label]));
        setPartnerMap(map);

        console.log(`PartnerService loaded ${map.size} entries`);

      } catch (error) {
        console.error("Error loading partners:", error);
        setPartnerMap(
          new Map([
            ["-101", "Airbnb"],
            ["-102", "MMT"],
            ["-103", "Google / Website (Direct)"],
            ["-104", "Repeat (Direct)"],
            ["-105", "Referral / Whatsapp Group"],
            ["0", "Walk-In"],
            ["-106", "Instagram"],
            ["-107", "Other"],
            ["1", "Corporate"],
          ])
        );
      }
    };

    loadPartners();
  }, []);

  const getPartnerName = (partnerId) => {
    return partnerMap.get(partnerId?.toString()) || "NA";
  };

  return { getPartnerName };
};

export default PartnerService;
